const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Copy the content of a field into a component field', () => {
  describe('preview copying a simple string field into a component field', () => {
    const mock = loadRecordedMock('copy_field_component_string_preview.json');
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?component&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy a simple string field into a component field', () => {
    const mock = loadRecordedMock('copy_field_commit_component_string.json');
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?component&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy a simple string field into a component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_component_string_repeat.json'
    );
    const n = 20;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?component&string&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying a string field into a repeatable component field', () => {
    const mock = loadRecordedMock(
      'copy_field_componentarray_string_preview.json'
    );
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?componentarray&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy a string field into a repeatable component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_componentarray_string.json'
    );
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?componentarray&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy a string field into a repeatable component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_componentarray_string_repeat.json'
    );
    const n = 20;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?componentarray&string&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying a string field into a nested components field', () => {
    const mock = loadRecordedMock(
      'copy_field_nestcomponent_string_preview.json'
    );
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?nestcomponent&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy a string field into a nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_nestcomponent_string.json'
    );
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?nestcomponent&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy a string field into a nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_nestcomponent_string_repeat.json'
    );
    const n = 23;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?nestcomponent&string&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying a string field into a repeatable nested components field', () => {
    const mock = loadRecordedMock(
      'copy_field_nestcomponentarray_string_preview.json'
    );
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?nestcomponentarray&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy a string field into a repeatable nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_nestcomponentarray_string.json'
    );
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?nestcomponentarray&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy a repeatable string field into a nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_nestcomponentarray_string_repeat.json'
    );
    const n = 23;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?nestcomponentarray&string&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying from a repeatable nested component field into a repeatable component nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_componentarraynestcomponent_nestcomponentarray_preview.json'
    );
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?componentarraynestcomponent&nestcomponentarray',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy from a repeatable nested component field into a repeatable component nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_componentarraynestcomponent_nestcomponentarray.json'
    );
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?componentarraynestcomponent&nestcomponentarray',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy from a repeatable nested component field into a repeatable component nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_componentarraynestcomponent_nestcomponentarray_repeat.json'
    );
    const n = 20;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?componentarraynestcomponent&nestcomponentarray&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview copying from a repeatable nested component field inside a repeatable component into a repeatable component nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_componentarraynestcomponentarray_componentarraynestcomponent_preview.json'
    );
    const n = 20;

    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?componentarraynestcomponentarray&componentarraynestcomponent',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('copy from a repeatable nested component field inside a repeatable component into a repeatable component nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_componentarraynestcomponentarray_componentarraynestcomponent.json'
    );
    const n = 20;

    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?componentarraynestcomponentarray&componentarraynestcomponent',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });

  describe('repeat the same copy from a repeatable nested component field inside a repeatable component into a repeatable component nested component field', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_componentarraynestcomponentarray_componentarraynestcomponent_repeat.json'
    );
    const n = 20;

    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?componentarraynestcomponentarray&componentarraynestcomponent&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });
});
